import { render } from "./survey_list.vue?vue&type=template&id=5afd7ff0&scoped=true"
import script from "./survey_list.vue?vue&type=script&lang=js"
export * from "./survey_list.vue?vue&type=script&lang=js"

import "./survey_list.vue?vue&type=style&index=0&id=5afd7ff0&lang=scss&scoped=true"
import "./survey_list.vue?vue&type=style&index=1&id=5afd7ff0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5afd7ff0"]])

export default __exports__